import { ModulePrefixes } from "./modules";

export const pageTitles = {
  [ModulePrefixes.SITES]: {
    title: "sites.title",
    explainerText: "sites.explainerText",
  },
  [ModulePrefixes.TEMPLATE_LIBRARY]: {
    title: "templateLibrary.title",
    explainerText: "templateLibrary.explainerText",
  },
  [ModulePrefixes.USERS]: {
    title: "users.title",
    explainerText: "users.explainerText",
  },
  [ModulePrefixes.SITE_TEMPLATE]: {
    title: "siteTemplate.title",
    explainerText: "siteTemplate.explainerText"
  },
  [ModulePrefixes.SITE_SETTINGS]: {
    title: "siteTemplate.title",
    explainerText: "siteTemplate.explainerText"
  },
  [ModulePrefixes.ACCOUNT_SETTINGS]: {
    title: "accountSettings.title",
    explainerText: "accountSettings.explainerText",
  },
  [ModulePrefixes.DASHBOARD]: {
    title: "dashboard.title",
    explainerText: "dashboard.explainerText",
  },
  "": {
    title: "dashboard.title",
    explainerText: "dashboard.explainerText",
  },
};
